<template>
  <header class="searchTabs">
    <v-container>
      <nav class="searchTabsNav">
        <ul>
          <li :class="{ active: active == 'news' }">
            <a :href="'/search/news?w=' + this.keyword">NCBオリジナル</a>
          </li>
          <li :class="{ active: active == 'curations' }">
            <a :href="'/search/curations?w=' + this.keyword">キュレーション</a>
          </li>
          <li :class="{ active: active == 'reports' }">
            <a :href="'/search/reports?w=' + this.keyword">レポート</a>
          </li>
          <li :class="{ active: active == 'seminars' }">
            <a :href="'/search/seminars?w=' + this.keyword">セミナー</a>
          </li>
          <li :class="{ active: active == 'fintechs' }">
            <a :href="'/search/fintechs?w=' + this.keyword">Fintech DB</a>
          </li>
        </ul>
      </nav>
    </v-container>
  </header>
</template>

<script>
export default {
  props: ["active", "keyword"]
};
</script>

<style lang="scss" scoped>
@import "../../sass/variables";

.search {
  &Tabs {
    margin: 40px 0 60px;
    & > .container {
      padding: 0;
    }
    &Nav {
      @include centerX;
      ul {
        list-style-type: none;
        display: flex;
        width: 600px;
        padding-left: 0;
        li {
          width: calc(100% / 3);
          a {
            @include centerXY;
            height: 60px;
            width: 100%;
            font-size: 1.1rem;
            color: $cText;
            border-bottom: 3px solid cBaseDk(8);
            &:hover {
              opacity: 1;
              color: $cKey;
              border-bottom: 3px solid $cKey;
            }
          }
          &.active {
            a {
              border-bottom: 3px solid $cKey;
            }
          }
        }
      }
    }
  }
}

// Small
@media screen and (max-width: 750px) {
  .search {
    &Tabs {
      &Nav {
        ul {
          li {
            a {
              font-size: 10px;
            }
          }
        }
      }
    }
  }
}
</style>
